const NEXT = 'EBIKE_NEXT';
const BACK = 'EBIKE_BACK';
const CHANGE_CHOICE = 'EBIKE_CHANGE_CHOICE';
const INIT_STEP = 'EBIKE_INIT_STEP';
const GOTO = 'EBIKE_GOTO';

export { NEXT, BACK, CHANGE_CHOICE, INIT_STEP, GOTO };